import type { FC } from 'react';

import { Icon } from '@zen/DesignSystem';
import type { SuggestionSource } from '@zen/graphql/types.generated';

import { enumToSentenceCase } from '../helpers';

interface SuggestionPopoverProps {
  id: string;
  onAccept: (id: string) => void;
  onReject: (id: string) => void;
  proposedValueText: string;
  sources: SuggestionSource[];
}

export const SuggestionPopover: FC<SuggestionPopoverProps> = ({ id, proposedValueText, onAccept, onReject, sources }) => {
  const iconClassNames: string = 'text-transparent right-4 cursor-pointer bg-sunset-base bg-clip-text';

  return (
    <div className="bg-sunset-base p-0.5">
      <div className="flex items-center p-4 gap-2 justify-between w-auto bg-white ">
        <div className="flex items-center gap-2">
          <span className="truncate max-w-40">{proposedValueText}</span>
        </div>

        <div className="flex items-center gap-2">
          <span className="text-grey-base">
            {sources.map((source) => {
              return `${enumToSentenceCase(source.source)}`;
            })}
          </span>
          <Icon onClick={() => onAccept(id)} className={iconClassNames} icon="zicon-tick" />
          <Icon onClick={() => onReject(id)} className={iconClassNames} icon="zicon-close" />
        </div>
      </div>
    </div>
  );
};
